import { cn } from "@/lib/utils";
import type { ReactNode } from "react";
import { NvStarIcon } from "./nv-icons";

// ver.6: the bookmark is the PwC "Star" graphic element (Figma 546:4614), #1A1C21 — 35% opacity when off, solid when on.
// 시안의 Bookmark 노드 크기 그대로: Card / Agent Result 23 x 23, Card / Agent Vertical 21 x 21 (546:5187 · 546:5192).
const SIZES = {
  md: 23,
  sm: 21,
} as const;

export interface NvBookmarkButtonProps {
  bookmarked: boolean;
  onToggle?: (next: boolean) => void;
  size?: keyof typeof SIZES;
  className?: string;
  icon?: ReactNode;
  disabled?: boolean;
  ariaLabel?: string;
}

function NvBookmarkButton({
  bookmarked,
  onToggle,
  size = "md",
  className,
  icon,
  disabled,
  ariaLabel,
}: NvBookmarkButtonProps) {
  return (
    <button
      type="button"
      aria-pressed={bookmarked}
      aria-label={ariaLabel ?? (bookmarked ? "북마크 해제" : "북마크")}
      disabled={disabled}
      onClick={() => onToggle?.(!bookmarked)}
      className={cn(
        "relative z-10 inline-flex shrink-0 items-center justify-center text-nv-text-primary transition-opacity",
        bookmarked ? "opacity-100" : "opacity-35 hover:opacity-70",
        className,
      )}
    >
      {icon ?? <NvStarIcon size={SIZES[size]} />}
    </button>
  );
}

export { NvBookmarkButton };
